import { useContext, useEffect, useState } from 'react';
import { UserStateContext } from 'context/user-state-context';
import { getTaskBoards } from '../../shared/common.api';

/**
 * CIN-7070: the current company's task boards, in their settings order (the first
 * is the default board). Shared by the Task Manager page and the task modals, which
 * all need the list up front to decide whether to show any board UI at all — a
 * single-board company sees none.
 *
 * `boards` is [] until loaded, after a company switch, and when the request fails;
 * callers treat a failure like a single-board company rather than block the page.
 * A response for a company the user has since switched away from is dropped.
 */
export const useTaskBoards = () => {
  const {
    asCompany
  } = useContext(UserStateContext);
  const [boards, setBoards] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!asCompany?.id) return undefined;
    let cancelled = false;
    setBoards([]);
    setLoaded(false);
    getTaskBoards({
      company: asCompany.id,
      limit: 999
    }).then(({
      data
    }) => !cancelled && setBoards(data.results || [])).catch(() => !cancelled && setBoards([])).finally(() => !cancelled && setLoaded(true));
    return () => {
      cancelled = true;
    };
  }, [asCompany?.id]);
  return {
    boards,
    loaded
  };
};